import { t as RelatedCoursesSkeleton } from "./related-courses-skeleton-DlCnmNMB.js";
import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-related-courses.tsx
var LazyRelatedCourses = lazy(() => import("./related-courses-yWg7IKl9.js").then((n) => n.n).then((module) => ({ default: module.RelatedCourses })));
function RelatedCourses({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(RelatedCoursesSkeleton, { ...props }),
		children: /* @__PURE__ */ jsx(LazyRelatedCourses, { ...props })
	});
}
function RelatedCoursesContent({ ...props }) {
	return /* @__PURE__ */ jsx(LazyRelatedCourses, { ...props });
}
var useRelatedCoursesContent = () => {
	return useMemo(() => ({ relatedCourses: {
		component: RelatedCoursesContent,
		loadingComponent: /* @__PURE__ */ jsx(RelatedCoursesSkeleton, {})
	} }), []);
};
//#endregion
export { RelatedCourses, useRelatedCoursesContent };
